import Star from '@carbon/icons-react/es/Star.js';
import StarFilled from '@carbon/icons-react/es/StarFilled.js';
import { Tooltip } from '@carbon/react';

interface FavoriteButtonProps {
  isFavorite: boolean;
  handleClick?: () => void;
  handleDeleteClick?: () => void;
}

export const StarButton: React.FC<FavoriteButtonProps> = ({
  isFavorite,
  handleClick,
  handleDeleteClick,
}) => {
  return isFavorite ? (
    <Tooltip label={'Unsave'}>
      <button
        className="text-blue-600 hover:opacity-80 transition"
        style={{ display: 'flex' }}
        onClick={handleDeleteClick}
        aria-label="Unsave"
      >
        <StarFilled size={16} />
      </button>
    </Tooltip>
  ) : (
    <Tooltip label={'Save'}>
      <button
        className="text-blue-600 hover:opacity-80 transition"
        style={{ display: 'flex' }}
        onClick={handleClick}
        aria-label="Save"
      >
        <Star size={16} />
      </button>
    </Tooltip>
  );
};
